import React from 'react';
import type { FormField, OpinionScaleConfig, ThemeConfig } from '../../../types/forms';

interface OpinionScaleFieldProps {
  field: FormField;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
  themeConfig?: ThemeConfig;
}

export const OpinionScaleField: React.FC<OpinionScaleFieldProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
  themeConfig,
}) => {
  const config = field.config as OpinionScaleConfig | undefined;
  const minValue = config?.minValue ?? 1;
  const maxValue = config?.maxValue ?? 10;
  const minLabel = config?.minLabel;
  const maxLabel = config?.maxLabel;

  const numbers = Array.from({ length: maxValue - minValue + 1 }, (_, i) => minValue + i);

  return (
    <div>
      <div className="flex flex-wrap gap-2 justify-center" role="radiogroup" aria-label={field.label}>
        {numbers.map((num) => {
          const isSelected = value === String(num);
          return (
            <button
              key={num}
              type="button"
              role="radio"
              aria-checked={isSelected}
              aria-label={`${num}${minLabel && num === minValue ? ` - ${minLabel}` : ''}${maxLabel && num === maxValue ? ` - ${maxLabel}` : ''}`}
              onClick={() => !disabled && onChange?.(String(num))}
              disabled={disabled}
              style={!isSelected && themeConfig?.textColor ? { color: themeConfig.textColor } : undefined}
              className={`
                min-w-11 min-h-11 rounded-xl text-sm font-medium
                transition-all duration-200
                ${isSelected
                  ? 'bg-primary-500 text-white border-primary-500'
                  : `bg-neutral-900/50 ${themeConfig?.textColor ? '' : 'text-neutral-300'} border ${error ? 'border-red-500' : 'border-neutral-700'} hover:border-neutral-500`
                }
                disabled:opacity-50 disabled:cursor-not-allowed
              `}
            >
              {num}
            </button>
          );
        })}
      </div>
      {(minLabel || maxLabel) && (
        <div className="flex justify-between mt-2 text-xs text-neutral-500">
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      )}
    </div>
  );
};
